var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pa-12 px-md-20 py-md-22 d-flex border-bottom"
  }, [_c('p', {
    class: 'font-weight-bold ' + _vm.spacing
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")]), _c('p', {
    staticClass: "d-flex align-baseline"
  }, [_vm._v(" " + _vm._s(_vm.sc) + " "), _vm._t("content")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }